import React, { useRef, useState, memo, useLayoutEffect } from "react";
import classes from "./Preview.scss";

const getScale = ({ parent, maxWidth, fitToWidth, width, height }) => {
  const parentWidth = parent.clientWidth;
  const parentHeight = parent.clientHeight;

  const targetWidth = maxWidth ? Math.min(parentWidth, maxWidth) : parentWidth;

  return fitToWidth
    ? targetWidth / width
    : Math.min(parentWidth / width, parentHeight / height);
};

const styles = {
  fitToWidthContainer: {
    minHeight: "100%",
  },
  container: {
    height: "100%",
  },
};

const Preview = ({ width, height, children, maxWidth, fitToWidth = false }) => {
  const parentRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const parent = parentRef.current;
    if (!parent) return;

    const observer = new ResizeObserver(() => {
      setScale(getScale({ parent, maxWidth, fitToWidth, width, height }));
    });
    observer.observe(parent);

    return () => observer.disconnect();
  }, [width, height, maxWidth, fitToWidth]);

  const scaledWidth = width * scale;
  const scaledHeight = height * scale;

  return (
    <div
      ref={parentRef}
      className={classes.container}
      style={fitToWidth ? styles.fitToWidthContainer : styles.container}
    >
      <div
        style={{
          width: scaledWidth,
          height: scaledHeight,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: width,
            height: height,
            transform: `scale(${scale})`,
            transformOrigin: "top left",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default memo(Preview);
